import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import SpecialitiesSection from "@/components/SpecialitiesSection";
import {
  ArrowLeft, ChevronRight, Calendar, MessageCircle, Phone, GraduationCap,
  Scissors, Heart, Shield, Users, MapPin, Building2, Microscope, Sparkles,
  Target, Brain, HandHeart, Stethoscope, Award, Activity
} from "lucide-react";


const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.55 } },
};

const stagger = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.06 } },
};

export default function SpecialitiesPage()  {
  return (
    <>
      <Helmet>
        <title>
          Dr. Neha Agarwal – Gynecologic Oncologist in Kolkata | Cancer & Robotic Surgeon
        </title>

        <meta
          name="description"
          content="Dr. Neha Agarwal is a leading gynecologic oncologist in Kolkata specializing in ovarian, cervical, uterine cancer, HIPEC, robotic and laparoscopic cancer surgery."
        />
      </Helmet>
      <div className="bg-[#F9F9F6] min-h-screen">

        <SpecialitiesSection />

     
      </div>
    </>
  );
}
